import { Grid } from "@mui/material";
import AddressCard from "../address-card";

const BookPaper = ({ meta }) => {
  return (
    <Grid
      container
      direction="row"
      className="address-book-paper"
      data-page-variant="addressbook-print-paper"
    >
      {meta.items.map((element) => (
        <Grid
          key={`item-id-${element.postId}`}
          item
          xs={3}
          className="grid-item"
        >
          <AddressCard data={element} />
        </Grid>
      ))}
    </Grid>
  );
};

export default BookPaper;
